<script>
    import axios from 'axios'
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import Checkbox from "primevue/checkbox";

    export default {
        data() {
            return {
                loading: false,
                error: null,
                model: {}
            }
        },
        props: ["name", "reportRid", "type", "target"],
        methods: {
            save(){
                let self = this;
                self.loading = true;

                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: this.model
                })
                    .then(function (response) {

                        self.loading = false;
                        window.location.reload();

                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });


            },
            onClose() {
                this.showModal = false;
                this.error = null
            },
            onOpen() {
                if (this.target === "all") {
                    this.model = {
                        organic: true,
                        context: true,
                    };
                } else {
                    this.model = {
                        organic: this.target === "organic",
                        context: this.target === "context",
                    };
                }
            }
        },
        computed: {
            getApiUrl(){
                return this.$config.API_URL + '/report/group/' + this.type + '/double/' + this.reportRid;
            },
            btnModalLabel(){
                return this.type === 'import' ? this.$t('lang.main.btn.add') : this.$t('lang.main.btn.delete');
            },
            getOrganicLabel() {
                return this.type === 'import' ? this.$t('lang.main.f_import_organic') : this.$t('lang.main.f_delete_organic');
            },
            getContextLabel() {
                return this.type === 'import' ? this.$t('lang.main.f_import_context') : this.$t('lang.main.f_delete_context');
            },
        },
        components: {
            AdaptersDialog,
            Checkbox,
        },
    }
</script>
<template>

    <AdaptersDialog
        :listener-id="name"
        :callback-on-show="onOpen"
        :callback-on-hide="onClose"
        :header="$t('lang.group_report.dd_header')"
        :loading="loading"
        :error-message="error"
        :button-agree-label="btnModalLabel"
        :callback-agree="save"
    >
        <template #content>
            <div class="formgroup-inline">
                <div class="field-checkbox">
                    <Checkbox v-model="model.organic" inputId="organic" binary />
                    <label for="organic">{{ getOrganicLabel }}</label>
                </div>
                <div class="field-checkbox">
                    <Checkbox v-model="model.context" inputId="context" binary />
                    <label for="context">{{ getContextLabel }}</label>
                </div>
            </div>
        </template>
    </AdaptersDialog>
</template>
